import { render, staticRenderFns } from "./ServiceRouteAssignments.vue?vue&type=template&id=a808886c&scoped=true"
import script from "./ServiceRouteAssignments.vue?vue&type=script&lang=js"
export * from "./ServiceRouteAssignments.vue?vue&type=script&lang=js"
import style0 from "./ServiceRouteAssignments.vue?vue&type=style&index=0&id=a808886c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a808886c",
  null
  
)

export default component.exports